import { Message } from '../interfaces/message';
import 'rxjs/add/operator/toPromise';
import { Injectable } from '@angular/core';
import EnvironmentService from '../services/environmentService';
import { Http } from '@angular/http';
import HttpError from '../models/httpError';

@Injectable()
export default class MessageService {

  private http: Http;
  private environmentService: EnvironmentService;

  constructor(http: Http, environmentService: EnvironmentService) {
    this.http = http;
    this.environmentService = environmentService;
  }

  getMessage(): Promise<Message> {
    return this.http.get(this.environmentService.helloWorldUrl, { withCredentials: true })
      .toPromise()
      .then(r => r.json())
      .catch(e => {
        throw new HttpError(e, this.environmentService.helloWorldUrl);
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/messageService.ts